function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M199.419 2.8291H199.247H199.075H198.989H198.903H198.816H198.73H198.644C196.835 2.8291 195.055 2.8291 193.763 2.85767C189.226 2.85767 185.12 5.31482 183.713 9.11482C183.34 10.172 182.564 12.3434 181.846 14.5434L181.818 14.5148C181.76 14.4577 181.674 14.4005 181.588 14.3434L179.894 19.3434C181.387 18.8862 186.469 17.4291 188.623 17.4005C189.657 17.372 192.097 17.4005 193.476 17.4005C197.41 17.4005 197.553 15.572 197.639 12.8577H189.111C189.886 12.4005 190.662 12.2291 191.552 12.2291C193.275 12.2291 196.117 12.2291 197.352 12.2291C199.678 12.2005 201.142 11.6577 201.63 9.68624C201.803 9.05767 201.946 8.31482 202.09 7.74339C200.712 7.74339 194.653 7.74339 191.868 7.74339C192.528 7.31482 193.562 7.08624 194.596 7.05767C194.854 7.05767 196.462 7.05767 198.242 7.05767C200.367 7.05767 202.722 7.05767 203.238 7.05767C204.818 7.00053 206.311 6.37196 206.799 4.08624C206.885 3.68624 206.971 3.28624 207.057 2.88624C207 2.8291 203.238 2.8291 199.419 2.8291Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.7391 14.8861H7.37953L5.51311 22.8575L0 22.8861L5.22597 0.54322L14.1273 0.514648C19.0949 0.514648 20.9613 4.00036 20.0999 7.68608C19.2385 11.3718 15.7353 14.8861 10.7391 14.8861ZM12.6916 5.45751H9.5618L8.52809 9.97179H11.6579C13.1798 9.97179 14.2996 8.8575 14.5868 7.71465C14.8452 6.54322 14.2135 5.42893 12.6916 5.45751Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.3371 20.4861C31.3271 22.1147 29.231 23.0004 26.4745 23.0004C23.7466 23.0004 22.0525 22.1433 20.7891 20.5147C18.9801 18.1718 19.8128 15.029 20.5881 11.6576C21.3633 8.28613 22.0238 5.17185 24.9239 2.80042C26.9339 1.17185 29.03 0.286133 31.7866 0.286133C34.5144 0.286133 36.2085 1.14328 37.472 2.77185C39.2809 5.1147 38.4482 8.25756 37.673 11.629C36.8977 15.0004 36.2373 18.1433 33.3371 20.4861ZM32.6193 6.14328C32.3321 5.60042 31.643 5.17185 30.638 5.17185C29.633 5.17185 28.7429 5.62899 28.1973 6.14328C27.5369 6.80042 27.0487 7.54328 26.1012 11.629C25.1536 15.7433 25.2972 16.4576 25.6417 17.1147C25.9289 17.6576 26.618 18.1147 27.623 18.1147C28.628 18.1147 29.5182 17.629 30.0637 17.1147C30.7241 16.4576 31.2123 15.7433 32.1598 11.6576C33.1074 7.57185 32.9638 6.82899 32.6193 6.14328Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.1986 22.7713H52.6905L51.628 11.7713L45.4258 22.7999H40.9464L39.9701 0.457031H45.7416L45.9426 12.257L52.3172 0.457031H56.2223L57.0837 12.257L62.7691 0.457031H68.5407L57.1986 22.7713Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.2959 22.7425L70.5218 0.399665L85.769 0.371094L84.6205 5.25681L74.8864 5.28538L74.025 9.02824L82.3521 8.99966L81.2035 13.8854L72.8764 13.9139L71.9575 17.8282L81.6916 17.7997L80.5431 22.6854L65.2959 22.7425Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94.5268 22.6859L92.4881 14.3716H90.6217L88.6691 22.6859H83.156L88.382 0.343025L97.2833 0.314453C102.251 0.314453 104.117 3.80017 103.256 7.48588C102.538 10.543 100.212 12.4573 98.2309 13.343L100.901 22.6573L94.5268 22.6859ZM95.8763 5.28588H92.7465L91.6841 9.80017H94.8139C96.3358 9.80017 97.4556 8.68588 97.7428 7.54302C98.0012 6.3716 97.3982 5.28588 95.8763 5.28588Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M121.92 14.6568H118.561L116.694 22.6283H111.181L116.407 0.285407L125.308 0.256836C130.276 0.256836 132.142 3.74255 131.281 7.42826C130.391 11.1425 126.888 14.6568 121.92 14.6568ZM123.873 5.22826H120.743L119.68 9.74255H122.81C124.332 9.74255 125.452 8.62826 125.739 7.48541C125.997 6.31398 125.366 5.22826 123.873 5.22826Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M140.469 22.5997L140.211 19.2854H133.32L131.453 22.6283H125.682L139.062 0.256836H143.312L146.27 22.5711L140.469 22.5997ZM139.35 8.74255L135.933 14.714H139.838L139.35 8.74255Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M154.769 22.7429C151.323 22.7429 148.682 22.1143 146.959 19.8L151.323 16.2857C152.214 17.4571 154.166 17.8571 155.975 17.8571C158.157 17.8571 159.363 17.1143 159.651 15.8286C159.765 15.2857 159.765 14.8571 159.507 14.5143C159.277 14.2286 158.875 14 158.157 13.9143L155.544 13.5429C153.621 13.2571 152.271 12.6 151.496 11.5714C150.692 10.5143 150.548 9 151.008 7.08571C151.955 3 155.745 0.0285714 160.857 0C164.073 0 166.312 0.742857 167.805 2.65714L163.527 6.11429C162.436 4.71429 160.569 4.8 159.564 4.8C157.641 4.8 156.607 5.91429 156.377 6.88571C156.32 7.17143 156.32 7.57143 156.578 7.91429C156.808 8.2 157.21 8.48571 157.956 8.57143L160.569 8.94286C162.522 9.22857 163.814 9.85714 164.561 10.7714C165.479 11.9429 165.566 13.6 165.077 15.6571C164.015 20.2571 159.507 22.7429 154.769 22.7429Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.055 22.7143C168.609 22.7143 165.967 22.0857 164.245 19.7714L168.609 16.2571C169.499 17.4286 171.452 17.8286 173.261 17.8286C175.443 17.8286 176.649 17.0857 176.936 15.8C177.051 15.2571 177.051 14.8286 176.793 14.4857C176.563 14.2 176.161 13.9714 175.443 13.8857L172.83 13.5143C170.906 13.2286 169.557 12.5714 168.781 11.5429C167.977 10.4857 167.834 8.97143 168.293 7.05714C169.212 3 173.002 0 178.114 0C181.33 0 183.569 0.742857 185.062 2.65714L180.784 6.11429C179.693 4.71429 177.826 4.8 176.821 4.8C174.898 4.8 173.864 5.91429 173.634 6.88571C173.577 7.17143 173.577 7.57143 173.835 7.91429C174.065 8.2 174.467 8.48571 175.213 8.57143L177.826 8.94286C179.779 9.22857 181.071 9.85714 181.818 10.7714C182.737 11.9429 182.823 13.6 182.335 15.6571C181.301 20.2286 176.793 22.7143 172.055 22.7143Z",
  fill: "white"
});

var SvgPowerpasslogo = function SvgPowerpasslogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 207,
    height: 23,
    viewBox: "0 0 207 23",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPowerpasslogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/powerpasslogo.85955207.svg";
export { ForwardRef as ReactComponent };